import { render, staticRenderFns } from "./CamposDinamicos.vue?vue&type=template&id=3b37b8c8"
import script from "./CamposDinamicos.vue?vue&type=script&lang=js"
export * from "./CamposDinamicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports